import { int32ToString, comparePrimitives, disposeSafe, getEnumerator, equals, safeHash } from "../fable-library.3.7.20/Util.js";
import { Record, toString, FSharpRef, Union } from "../fable-library.3.7.20/Types.js";
import { record_type, bool_type, list_type, union_type, class_type, array_type, tuple_type, string_type } from "../fable-library.3.7.20/Reflection.js";
import { map as map_1, forAll } from "../fable-library.3.7.20/Seq.js";
import { sortInPlaceBy, fold } from "../fable-library.3.7.20/Array.js";
import { addToDict, tryGetValue } from "../fable-library.3.7.20/MapUtil.js";
import { value as value_9, some, map } from "../fable-library.3.7.20/Option.js";
import { InstancePool$1__ReleaseInstance_2B595, InstancePool$1__ClaimInstance, List_mapAll, Array_binSearch } from "./More.fs.js";
import { fold as fold_1, empty, cons, toArray } from "../fable-library.3.7.20/List.js";
import { Buffer$1_$ctor, Buffer_append, Buffer_toList, $007CInt32Str$007C_$007C, $007CSingleStr$007C_$007C } from "./Tools.fs.js";
import { Parser_item, DataStream_ofString, Parser_isSpace, Parser_ignoreWhile_, Parser$2, Parser_charBuffers, Parser_isHexChar } from "./Parser.fs.js";
import { parse } from "../fable-library.3.7.20/Int32.js";
import { StringBuilder__Append_244C7CD6, StringBuilder_$ctor, StringBuilder__Append_Z721C83C5 } from "../fable-library.3.7.20/System.Text.js";
import { replicate, toFail, printf, toText } from "../fable-library.3.7.20/String.js";
import { Result_Map, FSharpResult$2 } from "../fable-library.3.7.20/Choice.js";

export class JSObject extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["JSObjArray", "JSObjDict"];
    }
    Equals(o) {
        const x = this;
        return (o instanceof JSObject) && JSObject_equal(x, o);
    }
    GetHashCode() {
        const x = this;
        return safeHash(JSObject__asSequence(x)) | 0;
    }
    ["System.IEquatable`1.Equals2B595"](other) {
        const x = this;
        return JSObject_equal(x, other);
    }
}

export function JSObject$reflection() {
    return union_type("Svea.Dry.JSON.JSObject", [], JSObject, () => [[["properties", array_type(tuple_type(string_type, JSVal$reflection()))]], [["d", class_type("System.Collections.Generic.IDictionary`2", [string_type, JSVal$reflection()])]]]);
}

export class JSVal extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["JSStr", "JSNumber", "JSObj", "JSArr", "JSBool", "JSNull"];
    }
}

export function JSVal$reflection() {
    return union_type("Svea.Dry.JSON.JSVal", [], JSVal, () => [[["Item", string_type]], [["Item", string_type]], [["Item", JSObject$reflection()]], [["Item", list_type(JSVal$reflection())]], [["Item", bool_type]], []]);
}

export function JSObject_equal(a, b) {
    if (forAll((tupledArg) => {
        const matchValue = JSObject__tryFind_Z721C83C5(b, tupledArg[0]);
        if (matchValue == null) {
            return false;
        }
        else {
            return equals(tupledArg[1], matchValue);
        }
    }, JSObject__asSequence(a))) {
        return forAll((tupledArg_1) => {
            const matchValue_1 = JSObject__tryFind_Z721C83C5(a, tupledArg_1[0]);
            if (matchValue_1 == null) {
                return false;
            }
            else {
                return equals(tupledArg_1[1], matchValue_1);
            }
        }, JSObject__asSequence(b));
    }
    else {
        return false;
    }
}

export function JSObject__fold(x, fn, seed) {
    if (x.tag === 1) {
        let acc_1 = seed;
        const enumerator = getEnumerator(x.fields[0]);
        try {
            while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
                const p = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
                acc_1 = fn(acc_1, p[0], p[1]);
            }
        }
        finally {
            disposeSafe(enumerator);
        }
        return acc_1;
    }
    else {
        return fold((acc, tupledArg) => fn(acc, tupledArg[0], tupledArg[1]), seed, x.fields[0]);
    }
}

export function JSObject__tryFind_Z721C83C5(x, name) {
    if (x.tag === 1) {
        let _arg;
        let outArg = null;
        _arg = [tryGetValue(x.fields[0], name, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        if (_arg[0]) {
            return _arg[1];
        }
        else {
            return void 0;
        }
    }
    else {
        return map((tuple_1) => tuple_1[1], Array_binSearch((tuple) => tuple[0], name, x.fields[0]));
    }
}

export function JSObject__asSequence(x) {
    if (x.tag === 1) {
        return map_1((kv) => [kv[0], kv[1]], x.fields[0]);
    }
    else {
        return x.fields[0];
    }
}

export function JSObj_ofArrayInPlace(properties) {
    sortInPlaceBy((tuple) => tuple[0], properties, {
        Compare: comparePrimitives,
    });
    return new JSVal(2, new JSObject(0, properties));
}

export function JSObj_ofList(properties) {
    return JSObj_ofArrayInPlace(toArray(properties));
}

export function JSObj_ofDictionary(d) {
    return new JSVal(2, new JSObject(1, d));
}

export function JSObj_toList(jsObj) {
    return JSObject__fold(jsObj, (acc, name, value) => cons([name, value], acc), empty());
}

export function JSFloat(f) {
    let value;
    return new JSVal(1, (value = (f + 0), value.toString()));
}

export function JSInt(i) {
    return new JSVal(1, int32ToString(i + 0));
}

export function $007CJSFloat$007C_$007C(j) {
    let pattern_matching_result, s;
    if (j.tag === 1) {
        const activePatternResult = $007CSingleStr$007C_$007C(false)(j.fields[0]);
        if (activePatternResult != null) {
            pattern_matching_result = 0;
            s = activePatternResult;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return s;
        }
        case 1: {
            return void 0;
        }
    }
}

export function $007CJSInt$007C_$007C(j) {
    let pattern_matching_result, s;
    if (j.tag === 1) {
        const activePatternResult = $007CInt32Str$007C_$007C(j.fields[0]);
        if (activePatternResult != null) {
            pattern_matching_result = 0;
            s = activePatternResult;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return s;
        }
        case 1: {
            return void 0;
        }
    }
}

export function tryJSStr(_arg) {
    if (_arg.tag === 0) {
        return _arg.fields[0];
    }
    else {
        return void 0;
    }
}

export function tryJSFloat(_arg) {
    const activePatternResult = $007CJSFloat$007C_$007C(_arg);
    if (activePatternResult != null) {
        const x = activePatternResult;
        return x;
    }
    else {
        return void 0;
    }
}

export function tryJSNumber(_arg) {
    if (_arg.tag === 1) {
        return _arg.fields[0];
    }
    else {
        return void 0;
    }
}

export function tryJSInt(_arg) {
    const activePatternResult = $007CJSInt$007C_$007C(_arg);
    if (activePatternResult != null) {
        const x = activePatternResult | 0;
        return x;
    }
    else {
        return void 0;
    }
}

export function tryJSObj(_arg) {
    if (_arg.tag === 2) {
        return _arg.fields[0];
    }
    else {
        return void 0;
    }
}

export function tryJSArr(_arg) {
    if (_arg.tag === 3) {
        return _arg.fields[0];
    }
    else {
        return void 0;
    }
}

export function tryJSBool(_arg) {
    if (_arg.tag === 4) {
        return _arg.fields[0];
    }
    else {
        return void 0;
    }
}

export function tryJSNull(_arg) {
    if (_arg.tag === 5) {
        return some(void 0);
    }
    else {
        return void 0;
    }
}

export function $007CJSProp$007C_$007C(key, jsObj) {
    return map((x) => [x, jsObj], JSObject__tryFind_Z721C83C5(jsObj, key));
}

export function $007CJSProps$007C_$007C(keys, jsObj) {
    return List_mapAll((key) => map((y) => [key, y], JSObject__tryFind_Z721C83C5(jsObj, key)), keys);
}

export function $007CJSObject$007C_$007C(keys, js) {
    if (js.tag === 2) {
        return List_mapAll((arg) => JSObject__tryFind_Z721C83C5(js.fields[0], arg), keys);
    }
    else {
        return void 0;
    }
}

export function $007CJSField$007C_$007C(name, js) {
    if (js.tag === 2) {
        return JSObject__tryFind_Z721C83C5(js.fields[0], name);
    }
    else {
        return void 0;
    }
}

export function toJSOption(f, _arg) {
    if (_arg == null) {
        return new JSVal(5);
    }
    else {
        return f(value_9(_arg));
    }
}

export function Internal_readJSEscChar(i$0027, ds) {
    if (ds.CanRead(i$0027 + 1)) {
        const matchValue = ds.Read(i$0027 + 1);
        let pattern_matching_result, c;
        switch (matchValue) {
            case "\"": {
                pattern_matching_result = 5;
                c = matchValue;
                break;
            }
            case "/": {
                pattern_matching_result = 5;
                c = matchValue;
                break;
            }
            case "\\": {
                pattern_matching_result = 5;
                c = matchValue;
                break;
            }
            case "b": {
                pattern_matching_result = 0;
                break;
            }
            case "f": {
                pattern_matching_result = 1;
                break;
            }
            case "n": {
                pattern_matching_result = 2;
                break;
            }
            case "r": {
                pattern_matching_result = 3;
                break;
            }
            case "t": {
                pattern_matching_result = 4;
                break;
            }
            case "u": {
                pattern_matching_result = 6;
                break;
            }
            default: pattern_matching_result = 7}
        switch (pattern_matching_result) {
            case 0: {
                return ["\b", i$0027 + 2];
            }
            case 1: {
                return ["\f", i$0027 + 2];
            }
            case 2: {
                return ["\n", i$0027 + 2];
            }
            case 3: {
                return ["\r", i$0027 + 2];
            }
            case 4: {
                return ["\t", i$0027 + 2];
            }
            case 5: {
                return [c, i$0027 + 2];
            }
            case 6: {
                if (ds.CanRead(i$0027 + 5)) {
                    const u0 = ds.Read(i$0027 + 2);
                    const u1 = ds.Read(i$0027 + 3);
                    const u2 = ds.Read(i$0027 + 4);
                    const u3 = ds.Read(i$0027 + 5);
                    if (((Parser_isHexChar(u0) && Parser_isHexChar(u1)) && Parser_isHexChar(u2)) && Parser_isHexChar(u3)) {
                        return [String.fromCharCode(parse([u0, u1, u2, u3].join(''), 515, true, 32)), i$0027 + 6];
                    }
                    else {
                        return void 0;
                    }
                }
                else {
                    return void 0;
                }
            }
            case 7: {
                return void 0;
            }
        }
    }
    else {
        return void 0;
    }
}

function Internal_readStringInternal(index, ds, charBuffer, res) {
    const bufferSize = charBuffer.length | 0;
    let sb = void 0;
    let bufferIndex = 0;
    let i = index;
    let readyAt = -1;
    let failed = false;
    let c = "\u0000";
    while ((ds.TryRead(i, new FSharpRef(() => c, (v) => {
        c = v;
    })) && (!failed)) && (readyAt === -1)) {
        switch (c) {
            case "\"": {
                readyAt = ((i + 1) | 0);
                break;
            }
            case "\\": {
                const matchValue = Internal_readJSEscChar(i, ds);
                if (matchValue == null) {
                    failed = true;
                }
                else {
                    const i$0027 = matchValue[1] | 0;
                    const c_1 = matchValue[0];
                    if (bufferIndex === bufferSize) {
                        let sb$0027_2;
                        if (sb != null) {
                            StringBuilder__Append_Z721C83C5(sb, charBuffer.join('').substr(0, bufferIndex));
                            sb$0027_2 = sb;
                        }
                        else {
                            const sb$0027 = StringBuilder_$ctor();
                            StringBuilder__Append_Z721C83C5(sb$0027, charBuffer.join('').substr(0, bufferIndex));
                            sb$0027_2 = sb$0027;
                        }
                        charBuffer[0] = c_1;
                        bufferIndex = 1;
                        i = (i$0027 | 0);
                        sb = sb$0027_2;
                    }
                    else {
                        const index_2 = bufferIndex | 0;
                        charBuffer[index_2] = c_1;
                        bufferIndex = ((bufferIndex + 1) | 0);
                        i = (i$0027 | 0);
                    }
                }
                break;
            }
            default: {
                const c_2 = c;
                if (bufferIndex === bufferSize) {
                    let sb$0027_5;
                    if (sb != null) {
                        StringBuilder__Append_Z721C83C5(sb, charBuffer.join('').substr(0, bufferIndex));
                        sb$0027_5 = sb;
                    }
                    else {
                        const sb$0027_3 = StringBuilder_$ctor();
                        StringBuilder__Append_Z721C83C5(sb$0027_3, charBuffer.join('').substr(0, bufferIndex));
                        sb$0027_5 = sb$0027_3;
                    }
                    charBuffer[0] = c_2;
                    bufferIndex = 1;
                    i = ((i + 1) | 0);
                    sb = sb$0027_5;
                }
                else {
                    const index_4 = bufferIndex | 0;
                    charBuffer[index_4] = c_2;
                    bufferIndex = ((bufferIndex + 1) | 0);
                    i = ((i + 1) | 0);
                }
            }
        }
    }
    if (readyAt === -1) {
        return -1;
    }
    else {
        if (sb == null) {
            res.contents = (charBuffer.join('').substr(0, bufferIndex));
        }
        else {
            const sb$0027_6 = sb;
            StringBuilder__Append_Z721C83C5(sb$0027_6, charBuffer.join('').substr(0, bufferIndex));
            res.contents = toString(sb$0027_6);
        }
        return readyAt | 0;
    }
}

export function Internal_parseNumber(buffer, i, ds, s) {
    let c_1, c_3, c_4, c_6, c_7, c_10, c_11, c_14, c_15;
    let bi = 0;
    let i$0027 = i;
    let c = "\u0000";
    if (ds.TryRead(i$0027, new FSharpRef(() => c, (v) => {
        c = v;
    }))) {
        if (((c_1 = c, (c_1 >= "0") && (c_1 <= "9"))) ? true : (c === "-")) {
            const c_2 = c;
            buffer[bi] = c_2;
            bi = ((bi + 1) | 0);
            i$0027 = ((i$0027 + 1) | 0);
            let c$0027 = "\u0000";
            while (ds.TryRead(i$0027, new FSharpRef(() => c$0027, (v_1) => {
                c$0027 = v_1;
            })) && (((c_3 = c$0027, (c_3 >= "0") && (c_3 <= "9"))) && (((c_4 = c$0027, (buffer[bi] = c_4, bi = ((bi + 1) | 0))), true)))) {
                i$0027 = ((i$0027 + 1) | 0);
            }
            let reject = false;
            if (((((c === "-") && (bi > 2)) && (buffer[1] === "0")) ? true : ((c === "0") && (bi > 1))) ? true : ((c === "-") && (bi === 1))) {
                reject = true;
            }
            if (ds.CanRead(i$0027)) {
                if (ds.Read(i$0027) === ".") {
                    buffer[bi] = ".";
                    bi = ((bi + 1) | 0);
                    i$0027 = ((i$0027 + 1) | 0);
                    const fracStart = i$0027 | 0;
                    let c$0027_1 = "\u0000";
                    while (ds.TryRead(i$0027, new FSharpRef(() => c$0027_1, (v_2) => {
                        c$0027_1 = v_2;
                    })) && (((c_6 = c$0027_1, (c_6 >= "0") && (c_6 <= "9"))) && (((c_7 = c$0027_1, (buffer[bi] = c_7, bi = ((bi + 1) | 0))), true)))) {
                        i$0027 = ((i$0027 + 1) | 0);
                    }
                    if (fracStart === i$0027) {
                        reject = true;
                    }
                }
                let c$0027_2 = "\u0000";
                if (ds.TryRead(i$0027, new FSharpRef(() => c$0027_2, (v_3) => {
                    c$0027_2 = v_3;
                }))) {
                    let pattern_matching_result, c_8;
                    switch (c$0027_2) {
                        case "E": {
                            pattern_matching_result = 0;
                            c_8 = c$0027_2;
                            break;
                        }
                        case "e": {
                            pattern_matching_result = 0;
                            c_8 = c$0027_2;
                            break;
                        }
                        default: pattern_matching_result = 1}
                    switch (pattern_matching_result) {
                        case 0: {
                            buffer[bi] = c_8;
                            bi = ((bi + 1) | 0);
                            i$0027 = ((i$0027 + 1) | 0);
                            const expStart = i$0027 | 0;
                            if (ds.TryRead(i$0027, new FSharpRef(() => c$0027_2, (v_4) => {
                                c$0027_2 = v_4;
                            }))) {
                                if ((c_10 = c$0027_2, ((c_10 === "-") ? true : (c_10 === "+")) ? true : ((c_11 = c_10, (c_11 >= "0") && (c_11 <= "9"))))) {
                                    const c_12 = c$0027_2;
                                    buffer[bi] = c_12;
                                    bi = ((bi + 1) | 0);
                                    i$0027 = ((i$0027 + 1) | 0);
                                    const expStart$0027 = i$0027 | 0;
                                    while (ds.TryRead(i$0027, new FSharpRef(() => c$0027_2, (v_5) => {
                                        c$0027_2 = v_5;
                                    })) && (((c_14 = c$0027_2, (c_14 >= "0") && (c_14 <= "9"))) && (((c_15 = c$0027_2, (buffer[bi] = c_15, bi = ((bi + 1) | 0))), true)))) {
                                        i$0027 = ((i$0027 + 1) | 0);
                                    }
                                    if (((c_12 === "-") ? true : (c_12 === "+")) && (expStart$0027 === i$0027)) {
                                        reject = true;
                                    }
                                }
                            }
                            if (expStart === i$0027) {
                                reject = true;
                            }
                            break;
                        }
                    }
                }
            }
            if ((bi === 1) && (c === "-")) {
                reject = true;
            }
            if (reject) {
                return false;
            }
            else {
                s.contents = (buffer.join('').substr(0, bi));
                return true;
            }
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}

export class Internal_ParseState extends Record {
    constructor(NullStr, NullJSVal, Res) {
        super();
        this.NullStr = NullStr;
        this.NullJSVal = NullJSVal;
        this.Res = Res;
    }
}

export function Internal_ParseState$reflection() {
    return record_type("Svea.Dry.JSON.Internal.ParseState", [], Internal_ParseState, () => [["NullStr", string_type], ["NullJSVal", JSVal$reflection()], ["Res", JSVal$reflection()]]);
}

export function Internal_parseArr(acceptClose_mut, depth_mut, buffer_mut, collected_mut, i_mut, ds_mut, state_mut) {
    let c_1, c_4;
    Internal_parseArr:
    while (true) {
        const acceptClose = acceptClose_mut, depth = depth_mut, buffer = buffer_mut, collected = collected_mut, i = i_mut, ds = ds_mut, state = state_mut;
        let i$0027_1;
        let i$0027 = i;
        let c = "\u0000";
        while (ds.TryRead(i$0027, new FSharpRef(() => c, (v) => {
            c = v;
        })) && ((c_1 = c, (c_1 === " ") ? true : ((c_1 >= "\t") && (c_1 <= "\r"))))) {
            i$0027 = ((i$0027 + 1) | 0);
        }
        i$0027_1 = i$0027;
        let c_2 = "\u0000";
        if (ds.TryRead(i$0027_1, new FSharpRef(() => c_2, (v_1) => {
            c_2 = v_1;
        }))) {
            if (c_2 === "]") {
                if (acceptClose) {
                    state.Res = (new JSVal(3, Buffer_toList(collected)));
                    return (i$0027_1 + 1) | 0;
                }
                else {
                    state.Res = (new JSVal(0, toText(printf("Unexpected closing of array at pos %d"))(i$0027_1)));
                    return -1;
                }
            }
            else {
                const matchValue = Internal_parseJson$0027(depth + 1, buffer, i$0027_1, ds, state) | 0;
                if (matchValue === -1) {
                    return -1;
                }
                else {
                    let i$0027$0027$0027;
                    let i$0027_2 = matchValue;
                    let c_3 = "\u0000";
                    while (ds.TryRead(i$0027_2, new FSharpRef(() => c_3, (v_2) => {
                        c_3 = v_2;
                    })) && ((c_4 = c_3, (c_4 === " ") ? true : ((c_4 >= "\t") && (c_4 <= "\r"))))) {
                        i$0027_2 = ((i$0027_2 + 1) | 0);
                    }
                    i$0027$0027$0027 = i$0027_2;
                    if (ds.TryRead(i$0027$0027$0027, new FSharpRef(() => c_2, (v_3) => {
                        c_2 = v_3;
                    }))) {
                        switch (c_2) {
                            case ",": {
                                acceptClose_mut = false;
                                depth_mut = depth;
                                buffer_mut = buffer;
                                collected_mut = ((Buffer_append(state.Res, collected), collected));
                                i_mut = (i$0027$0027$0027 + 1);
                                ds_mut = ds;
                                state_mut = state;
                                continue Internal_parseArr;
                            }
                            case "]": {
                                Buffer_append(state.Res, collected);
                                state.Res = (new JSVal(3, Buffer_toList(collected)));
                                return (i$0027$0027$0027 + 1) | 0;
                            }
                            default: {
                                const c_5 = c_2;
                                state.Res = (new JSVal(0, toText(printf("Illegal char \u0027%A\u0027 at pos %d"))(c_5)(i$0027$0027$0027)));
                                return -1;
                            }
                        }
                    }
                    else {
                        state.Res = (new JSVal(0, toText(printf("Illegal EOF at pos %d"))(i$0027$0027$0027)));
                        return -1;
                    }
                }
            }
        }
        else {
            state.Res = (new JSVal(0, toText(printf("Illegal EOF at pos %d"))(i$0027_1)));
            return -1;
        }
        break;
    }
}

export function Internal_parseObj(acceptClose_mut, depth_mut, buffer_mut, collected_mut, i_mut, ds_mut, state_mut) {
    let c_1, copyOfStruct, c_4, c_6, copyOfStruct_1, arg_2, copyOfStruct_3, arg_4;
    Internal_parseObj:
    while (true) {
        const acceptClose = acceptClose_mut, depth = depth_mut, buffer = buffer_mut, collected = collected_mut, i = i_mut, ds = ds_mut, state = state_mut;
        let i$0027_1;
        let i$0027 = i;
        let c = "\u0000";
        while (ds.TryRead(i$0027, new FSharpRef(() => c, (v) => {
            c = v;
        })) && ((c_1 = c, (c_1 === " ") ? true : ((c_1 >= "\t") && (c_1 <= "\r"))))) {
            i$0027 = ((i$0027 + 1) | 0);
        }
        i$0027_1 = i$0027;
        let c_2 = "\u0000";
        if ((copyOfStruct = ds, copyOfStruct.TryRead(i$0027_1, new FSharpRef(() => c_2, (v_1) => {
            c_2 = v_1;
        })))) {
            switch (c_2) {
                case "\"": {
                    let name = state.NullStr;
                    const matchValue = Internal_readStringInternal(i$0027_1 + 1, ds, buffer, new FSharpRef(() => name, (v_2) => {
                        name = v_2;
                    })) | 0;
                    if (matchValue === -1) {
                        state.Res = (new JSVal(0, toText(printf("Illegal fieldname at pos %d"))(i$0027_1)));
                        return -1;
                    }
                    else {
                        let i$0027$0027$0027;
                        let i$0027_2 = matchValue;
                        let c_3 = "\u0000";
                        while (ds.TryRead(i$0027_2, new FSharpRef(() => c_3, (v_3) => {
                            c_3 = v_3;
                        })) && ((c_4 = c_3, (c_4 === " ") ? true : ((c_4 >= "\t") && (c_4 <= "\r"))))) {
                            i$0027_2 = ((i$0027_2 + 1) | 0);
                        }
                        i$0027$0027$0027 = i$0027_2;
                        if (ds.TryRead(i$0027$0027$0027, new FSharpRef(() => c_2, (v_4) => {
                            c_2 = v_4;
                        }))) {
                            if (c_2 === ":") {
                                const matchValue_1 = Internal_parseJson$0027(depth + 1, buffer, i$0027$0027$0027 + 1, ds, state) | 0;
                                if (matchValue_1 === -1) {
                                    return -1;
                                }
                                else {
                                    let i$0027$0027$0027$0027$0027;
                                    let i$0027_3 = matchValue_1;
                                    let c_5 = "\u0000";
                                    while (ds.TryRead(i$0027_3, new FSharpRef(() => c_5, (v_5) => {
                                        c_5 = v_5;
                                    })) && ((c_6 = c_5, (c_6 === " ") ? true : ((c_6 >= "\t") && (c_6 <= "\r"))))) {
                                        i$0027_3 = ((i$0027_3 + 1) | 0);
                                    }
                                    i$0027$0027$0027$0027$0027 = i$0027_3;
                                    if (ds.TryRead(i$0027$0027$0027$0027$0027, new FSharpRef(() => c_2, (v_6) => {
                                        c_2 = v_6;
                                    }))) {
                                        switch (c_2) {
                                            case ",": {
                                                if ((copyOfStruct_1 = collected, copyOfStruct_1.has(name))) {
                                                    state.Res = (new JSVal(0, (arg_2 = name, toText(printf("Duplicate fieldname \u0027%s\u0027 at pos %d"))(arg_2)(i$0027_1))));
                                                    return -1;
                                                }
                                                else {
                                                    let copyOfStruct_2 = collected;
                                                    addToDict(copyOfStruct_2, name, state.Res);
                                                    acceptClose_mut = false;
                                                    depth_mut = (depth + 1);
                                                    buffer_mut = buffer;
                                                    collected_mut = collected;
                                                    i_mut = (i$0027$0027$0027$0027$0027 + 1);
                                                    ds_mut = ds;
                                                    state_mut = state;
                                                    continue Internal_parseObj;
                                                }
                                            }
                                            case "}": {
                                                if ((copyOfStruct_3 = collected, copyOfStruct_3.has(name))) {
                                                    state.Res = (new JSVal(0, (arg_4 = name, toText(printf("Duplicate fieldname \u0027%s\u0027 at pos %d"))(arg_4)(i$0027_1))));
                                                    return -1;
                                                }
                                                else {
                                                    let copyOfStruct_4 = collected;
                                                    addToDict(copyOfStruct_4, name, state.Res);
                                                    state.Res = JSObj_ofDictionary(collected);
                                                    return (i$0027$0027$0027$0027$0027 + 1) | 0;
                                                }
                                            }
                                            default: {
                                                const c_7 = c_2;
                                                state.Res = (new JSVal(0, toText(printf("Illegal char \u0027%A\u0027 at pos %d"))(c_7)(i$0027$0027$0027$0027$0027)));
                                                return -1;
                                            }
                                        }
                                    }
                                    else {
                                        state.Res = (new JSVal(0, toText(printf("Illegal EOF at pos %d"))(i$0027$0027$0027$0027$0027)));
                                        return -1;
                                    }
                                }
                            }
                            else {
                                const c_8 = c_2;
                                state.Res = (new JSVal(0, toText(printf("Illegal char \u0027%A\u0027 at pos %d"))(c_8)(i$0027$0027$0027)));
                                return -1;
                            }
                        }
                        else {
                            state.Res = (new JSVal(0, toText(printf("Illegal EOF at pos %d"))(i$0027$0027$0027)));
                            return -1;
                        }
                    }
                }
                case "}": {
                    if (acceptClose) {
                        state.Res = JSObj_ofDictionary(collected);
                        return (i$0027_1 + 1) | 0;
                    }
                    else {
                        state.Res = (new JSVal(0, toText(printf("Unexpected closing of object at pos %d"))(i$0027_1)));
                        return -1;
                    }
                }
                default: {
                    const c_9 = c_2;
                    state.Res = (new JSVal(0, toText(printf("Illegal char \u0027%A\u0027 at pos %d"))(c_9)(i$0027_1)));
                    return -1;
                }
            }
        }
        else {
            state.Res = (new JSVal(0, toText(printf("Illegal EOF at pos %d"))(i$0027_1)));
            return -1;
        }
        break;
    }
}

export function Internal_parseJson$0027(depth, buffer, i, ds, state) {
    let c_1, c_3;
    let i$0027_1;
    let i$0027 = i;
    let c = "\u0000";
    while (ds.TryRead(i$0027, new FSharpRef(() => c, (v) => {
        c = v;
    })) && ((c_1 = c, (c_1 === " ") ? true : ((c_1 >= "\t") && (c_1 <= "\r"))))) {
        i$0027 = ((i$0027 + 1) | 0);
    }
    i$0027_1 = i$0027;
    if (depth < 750) {
        let c_2 = "\u0000";
        if (ds.TryRead(i$0027_1, new FSharpRef(() => c_2, (v_1) => {
            c_2 = v_1;
        }))) {
            if (c_2 === "\"") {
                let s_1 = state.NullStr;
                const matchValue = Internal_readStringInternal(i$0027_1 + 1, ds, buffer, new FSharpRef(() => s_1, (v_2) => {
                    s_1 = v_2;
                })) | 0;
                if (matchValue === -1) {
                    state.Res = (new JSVal(0, toText(printf("Invalid string at pos %d"))(i)));
                    return -1;
                }
                else {
                    state.Res = (new JSVal(0, s_1));
                    return matchValue | 0;
                }
            }
            else if (c_2 === "[") {
                return Internal_parseArr(true, depth, buffer, Buffer$1_$ctor(), i$0027_1 + 1, ds, state) | 0;
            }
            else if (c_2 === "f") {
                let matchValue_3;
                const ds_3 = ds;
                const i_4 = (i$0027_1 + 1) | 0;
                matchValue_3 = (((((ds_3.CanRead(i_4 + 3) && (ds_3.Read(i_4) === "a")) && (ds_3.Read(i_4 + 1) === "l")) && (ds_3.Read(i_4 + 2) === "s")) && (ds_3.Read(i_4 + 3) === "e")) ? (i_4 + 4) : -1);
                if (matchValue_3 === -1) {
                    state.Res = (new JSVal(0, toText(printf("Invalid false at pos %d"))(i$0027_1)));
                    return -1;
                }
                else {
                    state.Res = (new JSVal(4, false));
                    return matchValue_3 | 0;
                }
            }
            else if (c_2 === "n") {
                let matchValue_1;
                const ds_1 = ds;
                const i_2 = (i$0027_1 + 1) | 0;
                let c_4 = "\u0000";
                matchValue_1 = ((((ds_1.CanRead(i_2 + 2) && (ds_1.Read(i_2) === "u")) && (ds_1.Read(i_2 + 1) === "l")) && (ds_1.Read(i_2 + 2) === "l")) ? (i_2 + 3) : -1);
                if (matchValue_1 === -1) {
                    state.Res = (new JSVal(0, toText(printf("Invalid null at pos %d"))(i$0027_1)));
                    return -1;
                }
                else {
                    state.Res = (new JSVal(5));
                    return matchValue_1 | 0;
                }
            }
            else if (c_2 === "t") {
                let matchValue_2;
                const ds_2 = ds;
                const i_3 = (i$0027_1 + 1) | 0;
                let c_5 = "\u0000";
                matchValue_2 = ((((ds_2.CanRead(i_3 + 2) && (ds_2.Read(i_3) === "r")) && (ds_2.Read(i_3 + 1) === "u")) && (ds_2.Read(i_3 + 2) === "e")) ? (i_3 + 3) : -1);
                if (matchValue_2 === -1) {
                    state.Res = (new JSVal(0, toText(printf("Invalid true at pos %d"))(i$0027_1)));
                    return -1;
                }
                else {
                    state.Res = (new JSVal(4, true));
                    return matchValue_2 | 0;
                }
            }
            else if (c_2 === "{") {
                return Internal_parseObj(true, depth, buffer, new Map([]), i$0027_1 + 1, ds, state) | 0;
            }
            else if ((c_3 = c_2, (c_3 === "-") ? true : ((c_3 >= "0") && (c_3 <= "9")))) {
                const c_6 = c_2;
                let s_2 = state.NullStr;
                if (Internal_parseNumber(buffer, i$0027_1, ds, new FSharpRef(() => s_2, (v_3) => {
                    s_2 = v_3;
                }))) {
                    state.Res = (new JSVal(1, s_2));
                    return (i$0027_1 + s_2.length) | 0;
                }
                else {
                    state.Res = (new JSVal(0, toText(printf("Invalid number at pos %d"))(i)));
                    return -1;
                }
            }
            else {
                const c_7 = c_2;
                state.Res = (new JSVal(0, toText(printf("Invalid char \u0027%A\u0027 at pos %d"))(c_7)(i)));
                return -1;
            }
        }
        else {
            state.Res = (new JSVal(0, toText(printf("Unexpected EOF at pos %d"))(i)));
            return -1;
        }
    }
    else {
        state.Res = (new JSVal(0, toText(printf("Exceeded maximum structure depth (%i) at pos %d"))(750)(i)));
        return -1;
    }
}

export function Internal_parseJson$0027$0027(i, s) {
    let c_1, copyOfStruct;
    const cBuffer = InstancePool$1__ClaimInstance(Parser_charBuffers);
    try {
        const state = new Internal_ParseState("", new JSVal(5), new JSVal(5));
        const matchValue = Internal_parseJson$0027(0, cBuffer, i, s, state) | 0;
        if (matchValue === -1) {
            const matchValue_1 = state.Res;
            return (matchValue_1.tag === 0) ? (new FSharpResult$2(1, matchValue_1.fields[0])) : toFail(printf("Invalid parser result %A"))(matchValue_1);
        }
        else {
            const i_1 = matchValue | 0;
            let i$0027_1;
            let i$0027 = i_1;
            let c = "\u0000";
            while (s.TryRead(i$0027, new FSharpRef(() => c, (v) => {
                c = v;
            })) && ((c_1 = c, (c_1 === " ") ? true : ((c_1 >= "\t") && (c_1 <= "\r"))))) {
                i$0027 = ((i$0027 + 1) | 0);
            }
            i$0027_1 = i$0027;
            return ((copyOfStruct = s, copyOfStruct.CanRead(i$0027_1))) ? (new FSharpResult$2(1, toText(printf("Additional characters at pos %d"))(i_1))) : (new FSharpResult$2(0, [state.Res, i_1]));
        }
    }
    finally {
        InstancePool$1__ReleaseInstance_2B595(Parser_charBuffers, cBuffer);
    }
}

export function Internal_parseJson$0027$0027$0027(i, s) {
    const _arg = Internal_parseJson$0027$0027(i, s);
    if (_arg.tag === 1) {
        return void 0;
    }
    else {
        return _arg.fields[0];
    }
}

export const Internal_jsVal = new Parser$2(0, Internal_parseJson$0027$0027$0027);

export function parseJsonToResult$0027(i, s) {
    return Result_Map((tuple) => tuple[0], Internal_parseJson$0027$0027(Parser_ignoreWhile_(Parser_isSpace, i, s), s));
}

export function dataStreamToJson(ds) {
    return parseJsonToResult$0027(0, ds);
}

export function stringToJson(s) {
    return dataStreamToJson(DataStream_ofString(s));
}

export class HandleJSStrNull extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["FailwithNullReferenceException", "ReplaceWithEmptyStr", "ReplaceWithNull"];
    }
}

export function HandleJSStrNull$reflection() {
    return union_type("Svea.Dry.JSON.HandleJSStrNull", [], HandleJSStrNull, () => [[], [], []]);
}

export class JsonWriteSettings extends Record {
    constructor(HandleJSStrNullAs, EscapeForwardSlash) {
        super();
        this.HandleJSStrNullAs = HandleJSStrNullAs;
        this.EscapeForwardSlash = EscapeForwardSlash;
    }
}

export function JsonWriteSettings$reflection() {
    return record_type("Svea.Dry.JSON.JsonWriteSettings", [], JsonWriteSettings, () => [["HandleJSStrNullAs", HandleJSStrNull$reflection()], ["EscapeForwardSlash", bool_type]]);
}

export function JsonWriteSettings_get_defaultSettings() {
    return new JsonWriteSettings(new HandleJSStrNull(0), true);
}

export function writeJsonIter(settings, indentionStr, indentionLevel, json, writeStr, writeChar) {
    const indentLen = indentionStr.length | 0;
    const writeIndention = (indentionLevel$0027) => {
        writeStr(replicate(indentionLevel$0027, indentionStr));
    };
    const writeJsonStr = (str) => {
        let arg, c_1, c_2;
        writeChar("\"");
        const enumerator = getEnumerator(str.split(""));
        try {
            while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
                const c = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
                let pattern_matching_result, c_3, c_4;
                if (c === "\b") {
                    pattern_matching_result = 1;
                }
                else if (c === "\t") {
                    pattern_matching_result = 4;
                }
                else if (c === "\n") {
                    pattern_matching_result = 0;
                }
                else if (c === "\f") {
                    pattern_matching_result = 2;
                }
                else if (c === "\r") {
                    pattern_matching_result = 3;
                }
                else if (c === "\"") {
                    pattern_matching_result = 5;
                }
                else if (c === "/") {
                    if (settings.EscapeForwardSlash) {
                        pattern_matching_result = 7;
                    }
                    else if ((c_1 = c, (c_1 >= "\u0000") && (c_1 <= "\u001f"))) {
                        pattern_matching_result = 8;
                        c_3 = c;
                    }
                    else {
                        pattern_matching_result = 9;
                        c_4 = c;
                    }
                }
                else if (c === "\\") {
                    pattern_matching_result = 6;
                }
                else if ((c_2 = c, (c_2 >= "\u0000") && (c_2 <= "\u001f"))) {
                    pattern_matching_result = 8;
                    c_3 = c;
                }
                else {
                    pattern_matching_result = 9;
                    c_4 = c;
                }
                switch (pattern_matching_result) {
                    case 0: {
                        writeStr("\\n");
                        break;
                    }
                    case 1: {
                        writeStr("\\b");
                        break;
                    }
                    case 2: {
                        writeStr("\\f");
                        break;
                    }
                    case 3: {
                        writeStr("\\r");
                        break;
                    }
                    case 4: {
                        writeStr("\\t");
                        break;
                    }
                    case 5: {
                        writeStr("\\\"");
                        break;
                    }
                    case 6: {
                        writeStr("\\\\");
                        break;
                    }
                    case 7: {
                        writeStr("\\/");
                        break;
                    }
                    case 8: {
                        writeStr((arg = (c_3.charCodeAt(0) | 0), toText(printf("\\u%04x"))(arg)));
                        break;
                    }
                    case 9: {
                        writeChar(c_4);
                        break;
                    }
                }
            }
        }
        finally {
            disposeSafe(enumerator);
        }
        writeChar("\"");
    };
    if (json.tag === 1) {
        writeStr(json.fields[0]);
    }
    else if (json.tag === 2) {
        writeChar("{");
        JSObject__fold(json.fields[0], (separatorFn, name, value) => {
            separatorFn();
            writeJsonStr(name);
            writeStr(" : ");
            writeJsonIter(settings, indentionStr, ((((indentionLevel + 1) + indentLen) + name.length) + 2) + 3, value, writeStr, writeChar);
            return () => {
                writeStr(", ");
                if (indentLen > 0) {
                    writeStr("\r\n");
                }
                writeIndention((indentionLevel + 1) + indentLen);
            };
        }, () => {
            writeStr(indentionStr);
        });
        writeStr(indentionStr);
        writeChar("}");
    }
    else if (json.tag === 3) {
        writeChar("[");
        fold_1((separatorFn_1, v) => {
            separatorFn_1();
            writeJsonIter(settings, indentionStr, (indentionLevel + 1) + indentLen, v, writeStr, writeChar);
            return () => {
                writeStr(", ");
                if (indentLen > 0) {
                    writeStr("\r\n");
                }
                writeIndention((indentionLevel + 1) + indentLen);
            };
        }, () => {
            writeStr(indentionStr);
        }, json.fields[0]);
        writeStr(indentionStr);
        writeChar("]");
    }
    else if (json.tag === 4) {
        writeStr(json.fields[0] ? "true" : "false");
    }
    else if (json.tag === 5) {
        writeStr("null");
    }
    else if (json.fields[0] === null) {
        const matchValue = settings.HandleJSStrNullAs;
        switch (matchValue.tag) {
            case 1: {
                writeJsonStr("");
                break;
            }
            case 2: {
                writeStr("null");
                break;
            }
            default: {
                throw (new Error());
            }
        }
    }
    else {
        writeJsonStr(json.fields[0]);
    }
}

export function customJsonToString(settings, indentionString, json) {
    const writer = StringBuilder_$ctor();
    writeJsonIter(settings, indentionString, 0, json, (x) => {
        StringBuilder__Append_Z721C83C5(writer, x);
    }, (x_1) => {
        StringBuilder__Append_244C7CD6(writer, x_1);
    });
    return toString(writer);
}

export function jsonToString(json) {
    return customJsonToString(JsonWriteSettings_get_defaultSettings(), "", json);
}

export function jsonToFormattedString(json) {
    return customJsonToString(JsonWriteSettings_get_defaultSettings(), " ", json);
}

export const pJSStr = (() => {
    const arg10$0040 = Parser_item();
    return new Parser$2(0, (i_1, s_1) => {
        let _arg;
        const matchValue = arg10$0040.fields[0](i_1, s_1);
        return (matchValue == null) ? (void 0) : ((_arg = matchValue[0], (_arg.tag === 0) ? (new Parser$2(0, (i, _arg_1) => [_arg.fields[0], i])) : (new Parser$2(0, (_arg_2, _arg_1_1) => (void 0))))).fields[0](matchValue[1], s_1);
    });
})();

export const pJSObj = (() => {
    const arg10$0040 = Parser_item();
    return new Parser$2(0, (i_1, s) => {
        let _arg;
        const matchValue = arg10$0040.fields[0](i_1, s);
        return (matchValue == null) ? (void 0) : ((_arg = matchValue[0], (_arg.tag === 2) ? (new Parser$2(0, (i, _arg_1) => [_arg.fields[0], i])) : (new Parser$2(0, (_arg_2, _arg_1_1) => (void 0))))).fields[0](matchValue[1], s);
    });
})();

